export default __webpack_public_path__ + "static/media/twitter-icon.e0cf1fcc.svg";